import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
import { routerReducer, routerMiddleware } from 'react-router-redux';
import { localizeReducer } from "react-localize-redux";

import * as Monitoring from './monitoringStore'
import * as AppContext from './appContextStore'
import * as UserContext from './userContextStore'
import * as Report from './reportStore'
import * as Popup from './popupStore'
import * as AmlCandidates from './amlCandidatesStore'
import * as Search from './searchStore'
import * as RegistrySearch from './ceeSearchStore'
import * as Domain from './domainStore'
import * as EntityIdentRow from './entityIdentRowStore'
import * as LayoutStore from './layoutStore';
import * as MarketingList from './marketingListStore';
import * as News from './newsStore';
import * as LastSubjects from './lastSubjectsStore';
import * as ChartSearch from './charts/chartsStore';
import * as ReportNav from './reportNavStore';
import * as RelationsSearch from './relationsSearchStore';
import * as Monitora from './monitoraStore';
import * as Alerts from './alertsStore';
import * as Windows from './windowStore';
import * as RightPanel from './rightPanelStore';
import * as IndustryAnalysis from './industryAnalysisStore';
import * as Reliability from './reliabilityStore';
import * as Repi from './repiStore';

export default function configureStore(history, initialState) {
    const reducers = {
        monitoring: Monitoring.reducer,
        appContext: AppContext.reducer,
        userContext: UserContext.reducer,
        report: Report.reducer,
        localize: localizeReducer,
        popup: Popup.reducer,
        amlCandidates: AmlCandidates.reducer,
        search: Search.reducer,
        registrySearch: RegistrySearch.reducer,
        domain: Domain.reducer,
        entityIdentRow: EntityIdentRow.reducer,
        layout: LayoutStore.reducer,
        marketingList: MarketingList.reducer,
        news: News.reducer,
        lastSubjects: LastSubjects.reducer,
        charts: ChartSearch.reducer,
        reportNav: ReportNav.reducer,
        relationsSearch: RelationsSearch.reducer,
        monitora: Monitora.reducer,
        alerts: Alerts.reducer,
        windows: Windows.reducer,
        rightPanel: RightPanel.reducer,
        industryAnalysis: IndustryAnalysis.reducer,
        reliability: Reliability.reducer,
        repi: Repi.reducer
    };

    const middleware = [thunk, routerMiddleware(history)];

    // In development, use the browser's Redux dev tools extension if installed
    const enhancers = [];
    const isDevelopment = process.env.NODE_ENV === 'development';
    if (isDevelopment && typeof window !== 'undefined' && window.devToolsExtension) {
        enhancers.push(window.devToolsExtension());
    }

    const store = createStore(
        combineReducers({ ...reducers, routing: routerReducer }),
        initialState,
        compose(applyMiddleware(...middleware), ...enhancers)
    );
    return store;
}
